const isIosHomeScreenApp = () => !!window.navigator.standalone

// eslint-disable-next-line import/prefer-default-export
export const isClinicalSetting = () => isIosHomeScreenApp()
